import PropTypes from 'prop-types';
import React from 'react';
import { beforeNow } from 'utils/LocalDateTimeHelper';
import ClockIcon from 'modules/Common/components/svg/ClockIcon';

export default function TimeSince({timestamp, title}) {
  const timeSince = beforeNow(timestamp);

  return (
      <span className="time-since"><ClockIcon title={title}/>&nbsp;{timeSince}</span>
  )
}

TimeSince.propTypes = {
    timestamp: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string, PropTypes.number]),
    title: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./modules/Common/components/TimeSince.js